import { render, staticRenderFns } from "./injuryWarn.vue?vue&type=template&id=2018e703&scoped=true&"
import script from "./injuryWarn.vue?vue&type=script&lang=js&"
export * from "./injuryWarn.vue?vue&type=script&lang=js&"
import style0 from "./injuryWarn.vue?vue&type=style&index=0&id=2018e703&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2018e703",
  null
  
)

export default component.exports